import moment, { Moment } from 'moment';

const dateFormat = 'DD MMM YYYY'
const timeFormat = 'HH:mm'

export const convertToDate = (dateString: string | undefined): Date | undefined => {
	if (!dateString) {
		return undefined;
	}

	return new Date(parseInt(dateString));
};

export const formatPublishDate = (date: Date | undefined, showTime: boolean): string | undefined => {
	if (!date) {
		return undefined;
	}
	const datePart = (isToday(date)) ? 'Today' : moment(date).format(dateFormat)
	const timePart = moment(date).format(timeFormat);

	if (showTime) {
		return `${datePart} ${timePart}`;
	}

	return `${datePart}`;
}

export const formatDisplayDate = (date: Date | number | string | undefined, showTime = true): string | undefined => {
	return (date) ? moment.utc(date).format(`${dateFormat}${showTime ? ` ${timeFormat}` : ''}`) : undefined;
}

function isToday(dateParameter: Date) {
	const today = new Date();
	return dateParameter.getDate() === today.getDate()
		&& dateParameter.getMonth() === today.getMonth()
		&& dateParameter.getFullYear() === today.getFullYear();
}

export const formatDisplayDateTime = (date: Date | undefined, useMomentInTime: boolean): string | undefined => {
	if (!date) {
		return undefined;
	}

	if (useMomentInTime) {
		return moment(date).fromNow();
	}

	return moment(date).format('D MMM YYYY [at] HH:mm');
}

export const configureLongDateFormat = (): void => {
	moment.updateLocale('en', {
		longDateFormat: {
			LT: 'hh:mm',
			LTS: 'h:mm:ss A',
			L: 'MM/DD/YYYY',
			l: 'M/D/YYYY',
			LL: 'MMMM Do YYYY',
			ll: 'MMM D YYYY',
			LLL: 'MMMM Do YYYY LT',
			lll: 'MMM D YYYY LT',
			LLLL: 'dddd, MMMM Do YYYY LT',
			llll: 'ddd, MMM D YYYY LT'
		}
	});
}

export const getDateInCustomCalendarDateFormat = (date: string) => {
	const callback = () => `[${moment(date).fromNow()}]`;

	moment.updateLocale('en', {
		calendar: {
			lastDay: '[Yesterday] HH:mm',
			sameDay: '[Today] HH:mm',
			nextDay: '[Tomorrow] HH:mm',
			lastWeek: callback,
			nextWeek: callback,
			sameElse: callback
		}
	});

	return moment(date).calendar();
}

export const getStartOfTheDay = (date?: Date) => {
	if (date) return new Date(date).setUTCHours(0, 0, 0, 0)
	return new Date().setUTCHours(0, 0, 0, 0)
}

export const getEndOfTheDay = (date?: Date) => {
	if (date) return new Date(date).setUTCHours(23, 59, 59, 0)
	return new Date().setUTCHours(23, 59, 59, 0)
}

export const getDateEndOfTheDay = (date?: Moment | Date | string) => {
	if (date) return moment(date).endOf('day').toISOString(true);
	return moment().endOf('day').toISOString(true);
}

export const getTomorrowDate = (date?: Date) =>
	moment(date).add(1, 'day').toISOString(true);

export const dateComparator = (date1: Date | string, date2: Date | string): number => {
	const firstDate = new Date(date1);
	const secondDate = new Date(date2);
	return (firstDate < secondDate) ? -1 : (firstDate > secondDate) ? 1 : 0;
};
